module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"search_placeholder":"レビューキーワード検索"}}')
  delete Component.options._Ctor
}
